import { useContext } from "react";
import { ThemeContext } from "../context/themeContext";

function useTheme() {
  const { theme, updateTheme } = useContext(ThemeContext);

  return {
    theme,
    updateTheme,
  };
}

export default useTheme;
